import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_GUIDES_BLOCKS_QUERY,
  CREATE_TRAVEL_GUIDES_BLOCK_MUTATION,
  DELETE_TRAVEL_GUIDES_BLOCK_MUTATION,
  FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION,
  SINGLE_TRAVEL_GUIDES_BLOCK_QUERY,
  UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION,
} from './graphql'
import travelGuideEntity from '@/entities/travelGuide/entity'

const cmsTravelGuidesBlockModel: EntityModel = {
  name: 'travelGuidesBlock',
  namePlural: 'travelGuidesBlocks',
  uniqueName: 'cmsTravelGuidesBlock',
  uniqueNamePlural: 'cmsTravelGuidesBlocks',
  path: 'cms/blocks/travel_guides_block',
  baseUrl: '/cms/blocks/travel_guides_blocks',
  translationPrefix: 'entities:cmsTravelGuidesBlock.',
  getDisplayName: (values: any) => {
    return 'TRAVEL GUIDES BLOCK'
  },
  gql: {
    getAll: ALL_TRAVEL_GUIDES_BLOCKS_QUERY,
    getSingle: SINGLE_TRAVEL_GUIDES_BLOCK_QUERY,
    create: CREATE_TRAVEL_GUIDES_BLOCK_MUTATION,
    update: UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION,
    delete: DELETE_TRAVEL_GUIDES_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION,
  },
  attributes: {
    travelGuides: {
      name: 'travelGuides',
      label: 'entities:cmsTravelGuidesBlock.attributes.travelGuides.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelGuideEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsTravelGuidesBlockModel
